<template>
	<div class="container-fluid">
		<navigation-admin></navigation-admin>
		<div class="row row-fluid admin-background wrapper-flexbox">
			<sidebar-admin></sidebar-admin>
			<section class="col-sm-10 admin-background-shadow">
			<br><br><br><br>
				<div class="row">
					<div class="col-sm-7">
						<label  class="admin-text" for="prod-search">Texto del slide</label><br>
						<input v-model="form.text"  id="prod-search" class="admin-input" type="text" placeholder="Agrega el texto al slide">
					</div>
				</div>
				<div class="row">
					<div class="col-sm-6">
						<div class="padding-top-sm">
							<p class="admin-text pull-left">Imágenes de slide</p>
							<span class="admin-text"><strong>1920x600px</strong></span>
						</div><br>
						<label class="btn btn-black btn-md btn-file">
						    Subir imagen <input @change="appendImg" type="file" style="display: none;">
						</label>
						<span class="admin-text pull-right">{{ file_name }}</span>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-6">
						<label class="admin-text" for="prod-search">Enlace del slide</label><br>
						<input v-model="form.url"  id="prod-search" class="admin-input" type="text" placeholder="Agrega el enlace del slide">
					</div>
				</div>
				<br><br><br><br>
				<div class="row">
					<div class="col-sm-6">
						<button @click="addSlider" class="btn btn-black btn-lg">
							Guardar
						</button>
					</div>
				</div>
			</section>
		</div>
	</div>

  <loader-full v-if="is_submited"></loader-full>
</template>

<style scoped>
	.tab-content{
		padding-left: 20px;
	}
	.admin-background-shadow{
    	background: #f4f4f8;
	}
	section{
		width: 100%;
	}
</style>

<script>
import navigationAdmin from '../../components/Admin/Admin-navigation.vue';
import sidebarAdmin from '../../components/Admin/Admin-sidebar.vue';
import productNavbar from '../../components/Admin/Admin-product-navbar.vue';
import productGeneral from '../../components/Admin/Admin-product-general.vue';
import productShipping from '../../components/Admin/Admin-products-shipping.vue';
import tableComplement from '../../components/Admin/Admin-product-complement.vue';
import LoaderFull from '../../components/Loader-full.vue';
import { addNewSlider } from '../../store/actions';

var form = {
	url: '',
	text: '',
	img: ''
};

export default {
	// ------ COMPONENTS ------

  components: {
    navigationAdmin,
    sidebarAdmin,
    productNavbar,
    productGeneral,
    productShipping,
    tableComplement,
    LoaderFull
  },

  // ------ DATA ------

  data(){
  	return{
  		form: form,
  		file_name: '',
      is_submited: false
  	};
  },

  // ------ VUEX ------

  vuex: {
		getters: {
			current_user: state => state.current_user
		},
		actions: {
			addNewSlider
		}
	},

	// ------ METHODS ------

	methods:{
		appendImg(e) {
      let file = e.target.files[0];
			// Add the product images.
      this.file_name = file.name;
			this.form.img = file;
		},

    addSlider() {
      this.is_submited = true;
      this.addNewSlider(this.form, this.current_user, this);
    }
	}
}	
</script>


// WEBPACK FOOTER //
// Admin-slider-new.vue?79d660e8